// ============================================================
// 🎨 UI 渲染函数 — 提取自 dnf.html
// ============================================================

import { S, save, renderTopbar, renderStatusbar } from '../state.js';
import { toast } from '../utils.js';
import { CLASSES } from '../data/classes.js';
import { REGIONS, DUNGEONS, DUNGEON_CHAINS, NPCS, ZONES } from '../data/world.js';
import { getMonsterData, getMonsterImage } from '../data/monsters.js';
import { EQUIPMENT_DB, TIERS, CONSUMABLES, getEquipById } from '../data/equipment.js';
import { switchBGM } from '../audio.js';
import { ITEM_ICONS, getEquipStats, getAtkEffectDesc } from '../utils.js';

// ========== 认证界面 ==========

export function showAuthUI() {
  switchBGM('default');
  const main = document.getElementById('main');
  const bgmIcon = window.bgmOn ? '🔊' : '🔇';
  document.getElementById('topbar').innerHTML = `<span class="text-gold">阿拉德战记</span><span>v5.0</span><button id="bgmBtn" onclick="toggleBGM()" class="bgm-btn">${bgmIcon}</button>`;
  document.getElementById('statusbar').innerHTML = '';
  main.innerHTML = `<div class="auth-container">
    <div class="auth-card">
      <div class="lobby-title" style="margin-bottom:20px;">阿拉德战记</div>
      <div style="color:var(--dim);text-align:center;margin-bottom:24px;">云端冒险，随时随地继续你的旅程</div>
      <div id="authForm"></div>
      <div id="authMsg" style="color:var(--red);text-align:center;margin-top:8px;min-height:20px;"></div>
      <div style="text-align:center;margin-top:16px;">
        <button class="auth-switch-btn" onclick="toggleAuthMode()">没有账号？去注册 →</button>
      </div>
    </div>
  </div>`;
  renderAuthForm('login');
}

export function renderAuthForm(mode) {
  const el = document.getElementById('authForm');
  if(!el) return;
  const isLogin = mode === 'login';
  el.innerHTML = `
    <input id="authUser" class="auth-input" placeholder="用户名" maxlength="20">
    <input id="authPass" class="auth-input" type="password" placeholder="密码" maxlength="50">
    <button class="auth-btn" onclick="doAuth()">${isLogin ? '登 录' : '注 册'}</button>
  `;
  const swBtn = document.querySelector('.auth-switch-btn');
  if(swBtn) swBtn.textContent = isLogin ? '没有账号？去注册 →' : '已有账号？去登录 →';
  setTimeout(() => { const inp = document.getElementById('authUser'); if(inp) inp.focus(); }, 100);
}

// ========== 角色列表 ==========

export function renderCharacterList(chars, allowOffline) {
  const main = document.getElementById('main');
  const username = localStorage.getItem('dnf_username') || '冒险家';
  let html = `<div class="auth-container"><div class="auth-card" style="max-width:480px;">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;">
      <span style="color:var(--gold);font-size:14px;">👤 ${username}</span>
      <button onclick="doLogout()" class="logout-btn">退出</button>
    </div>
    <div class="lobby-title" style="font-size:18px;margin-bottom:16px;">选择角色</div>`;

  if(chars.length === 0) {
    html += `<div style="color:var(--dim);text-align:center;padding:20px;">还没有角色，创建一个吧！</div>`;
  } else {
    html += `<div class="char-list">`;
    chars.forEach(c => {
      const clsInfo = CLASSES[c.class_id];
      const clsName = clsInfo ? clsInfo.name : c.class_id;
      html += `<div class="char-list-item" onclick="selectCharacter(${c.id})">
        <div style="font-size:24px;">${clsInfo ? (clsInfo.emoji||'⚔️') : '⚔️'}</div>
        <div style="flex:1;">
          <div style="color:var(--gold);">${c.name} <span style="font-size:10px;color:var(--dim);">Lv.${c.level}</span></div>
          <div style="font-size:10px;color:var(--dim);">${clsName} · ❤️${c.hp}/${c.max_hp} · 💰${c.gold}G</div>
        </div>
        <button class="char-del-btn" onclick="event.stopPropagation();deleteCharacter(${c.id})" title="删除">✕</button>
      </div>`;
    });
    html += `</div>`;
  }

  html += `<button class="auth-btn" style="margin-top:16px;" onclick="showCreateCharacterUI()">+ 创建新角色</button>
    ${allowOffline ? `<div style="text-align:center;margin-top:12px;"><button onclick="startOffline()" style="background:none;color:var(--dim);border:none;cursor:pointer;font-size:11px;">离线模式（本地存档）</button></div>` : ''}
  </div></div>`;
  main.innerHTML = html;
}

export function showCreateCharacterUI() {
  const main = document.getElementById('main');
  let html = `<div class="auth-container"><div class="auth-card">
    <div class="lobby-title" style="font-size:18px;margin-bottom:20px;">创建新角色</div>
    <input id="newCharName" class="auth-input" placeholder="角色名（最多10字）" maxlength="10">
    <div style="color:var(--dim);margin:8px 0;">选择职业：</div>
    <div class="class-select-grid">`;
  Object.entries(CLASSES).forEach(([cid, cls]) => {
    html += `<div class="class-select-item" onclick="selectClass('${cid}')" id="cls-${cid}">
      <div style="font-size:20px;">${cls.emoji||'⚔️'}</div>
      <div>${cls.name}</div>
      <div style="font-size:9px;color:var(--dim);">${cls.faction}</div>
    </div>`;
  });
  html += `</div>
    <div id="selectedClass" style="color:var(--gold);text-align:center;margin:10px 0;min-height:18px;"></div>
    <button class="auth-btn" onclick="doCreateCharacter()">创建角色</button>
    <button class="auth-btn" style="background:#1a1a24;margin-top:8px;" onclick="loadCharacterList()">← 返回</button>
    <div id="createMsg" style="color:var(--red);text-align:center;margin-top:8px;"></div>
  </div></div>`;
  main.innerHTML = html;
  window._selectedClass = null;
}

// ========== 大厅 ==========

export function renderLobby() {
  switchBGM('lobby');
  const main = document.getElementById('main');
  if(!S.name) { renderChooseClass(); return; }
  window.sfxSeraWelcome();
  const cls = S.cls ? CLASSES[S.cls] : null;
  const stats = getEquipStats();
  const effAtk = S.atk + stats.bonusAtk + stats.bonusStr;
  const effDef = S.def + stats.bonusDef;
  const effSpd = S.spd + stats.bonusSpd;
  const totalInt = stats.bonusInt;
  const hpPct = Math.max(0, Math.round(S.hp/S.maxHp*100));
  const mpPct = Math.max(0, Math.round((S.mp||0)/(S.maxMp||50)*100));
  const expPct = Math.max(0, Math.min(100, Math.round(S.exp/S.expNeed*100)));

  const classImg = S.cls ? `assets/class_${S.cls}.png` : '';

  let html = `<div class="lobby-container">`;
  html += `<div class="lobby-title">阿拉德战记</div>`;

  // 角色卡片
  const factionKey = { '鬼剑士':'faction-ghost', '神枪手':'faction-gunner', '圣职者':'faction-knight' };
  const factionClass = cls ? (factionKey[cls.faction] || '') : '';
  html += `<div class="char-card ${factionClass}">
    <div class="char-card-header">
      <img class="char-portrait" src="${classImg}" onerror="this.style.display='none'">
      <div>
        <div class="char-info-name">${S.name}${cls ? ` <span style="font-size:10px;color:var(--dim)">${cls.weapon}</span>` : ''}</div>
        <div class="char-info-sub">Lv.${S.lv} · ${cls ? cls.faction : ''} · 💰 ${S.gold}G</div>
        ${(()=>{const r=window.getRepPath();return '<div class="char-info-rep" style="font-size:10px;color:var(--dim);margin-top:2px;">'+(r==='hero'?'✨ 仁者之路':r==='shadow'?'🌑 暗影之路':r==='leaning_hero'?'⭐ 倾向光明':r==='leaning_shadow'?'🌙 倾向暗影':'⚖️ 中立')+'</div>';})()}
      </div>
    </div>
    <div class="hpmp-bars">
      <div class="bar-row">
        <span class="bar-label">HP</span>
        <div class="bar-track"><div class="bar-fill-hp" style="width:${hpPct}%"></div></div>
        <span class="bar-text">${S.hp}/${S.maxHp}</span>
      </div>
      <div class="bar-row">
        <span class="bar-label">MP</span>
        <div class="bar-track"><div class="bar-fill-mp" style="width:${mpPct}%"></div></div>
        <span class="bar-text">${S.mp||0}/${S.maxMp||50}</span>
      </div>
      <div class="bar-row">
        <span class="bar-label">EXP</span>
        <div class="bar-track"><div class="bar-fill-exp" style="width:${expPct}%"></div></div>
        <span class="bar-text">${S.exp}/${S.expNeed}</span>
      </div>
    </div>
    <div class="char-stats">
      <div class="char-stat">⚔️<span class="char-stat-val">${effAtk}</span></div>
      <div class="char-stat">🛡️<span class="char-stat-val">${effDef}</span></div>
      <div class="char-stat">💨<span class="char-stat-val">${effSpd}</span></div>
      ${totalInt > 0 ? `<div class="char-stat">🔮<span class="char-stat-val">${totalInt}</span></div>` : ''}
      <div class="char-stat">⚡<span class="char-stat-val">${S.fatigue}/${S.maxFatigue}</span></div>
    </div>
  </div>`;

  // 章节故事按钮（有解锁章节时显示）
  // 任务进度提示
  const activeQuests = window.getActiveQuests();
  if(activeQuests.length > 0) {
    html += '<div class="active-quests-hint" onclick="renderQuestLog()">📋 任务 ('+activeQuests.length+')</div>';
  }

  html += `<div class="lobby-story-btn-wrapper">
    <button class="lobby-story-btn" onclick="renderChapterStories()">📖 章节故事</button>
    <button class="lobby-story-btn" onclick="renderNotebook()">📓 冒险笔记</button>
  </div>`;

  // 管理后台入口（轻量链接）
  html += `<div style="text-align:center;margin-top:6px;">
    <a href="admin.html" target="_blank" style="color:var(--dim);font-size:10px;text-decoration:none;opacity:0.4;">⚙️ GM</a>
  </div>`;

  // NPC 区域
  html += `<div class="npc-section">
    <div class="progress-title">── 赛丽亚的旅馆 ──</div>
    <div class="npc-row">`;
  Object.values(NPCS).forEach(npc => {
    const isHere = npc.location.includes('lobby');
    if(!isHere) return;
    html += `<div class="npc-card" onclick="openNPCShop('${npc.id}')">
      ${npc.image ? `<img src="${npc.image}" class="npc-card-avatar" onerror="this.parentElement.querySelector('.npc-emoji').style.display='block';this.remove();" alt="${npc.name}"><div class="npc-emoji" style="display:none">${npc.emoji}</div>` : `<div class="npc-emoji">${npc.emoji}</div>`}
      <div class="npc-name">${npc.name}</div>
      <div class="npc-title">${npc.title}</div>
    </div>`;
  });
  html += `</div></div>`;

  // 进度
  html += `<div class="lobby-progress">
    <div class="progress-title">── 冒险进度 ──</div>`;
  REGIONS.forEach(reg => {
    const done = S.flags[reg.flag];
    const currentScene = S.scene;
    const isInRegion = reg.beatenScenes && reg.beatenScenes.some(s => currentScene === s);
    const dotClass = done ? 'done' : (isInRegion ? 'active' : '');
    const statusText = done ? '✓ 已通关' : (S.lv >= reg.lvReq ? '可进入' : `需 Lv.${reg.lvReq}`);
    html += `<div class="progress-region">
      <span class="progress-dot ${dotClass}"></span>
      <span class="progress-name">${reg.icon} ${reg.name}</span>
      <span class="progress-status">${statusText}</span>
    </div>`;
  });
  html += `</div>`;

  // 继续冒险按钮（如果有存档场景且不是lobby）
  if(S.scene && S.scene !== 'lobby') {
    const scene = window.getScene(S.scene);
    const sceneName = scene ? scene.title : S.scene;
    html += `<button class="continue-btn" style="margin-bottom:10px;font-size:14px;" onclick="S.scene='${S.scene}';renderScene();renderStatusbar();">▶ 继续冒险 — ${sceneName}</button>`;
  }

  // 区域传送门
  html += `<div class="region-portals">`;
  REGIONS.forEach(reg => {
    const locked = S.lv < reg.lvReq;
    html += `<button class="region-portal${locked?' locked':''}" onclick="enterRegion('${reg.id}')">
      <span class="rp-name">${reg.icon} ${reg.name}</span>
      <span class="rp-lv">Lv.${reg.lvReq}+</span>
      <div class="rp-desc">${reg.desc}</div>
      ${locked ? `<div class="rp-lock">🔒 需要 Lv.${reg.lvReq}</div>` : ''}
    </button>`;
  });
  html += `</div>`;

  // 底部按钮
  html += `<div class="lobby-bottom">
    <button class="lobby-btn" onclick="showInventory()">🎒 背包</button>
    <button class="lobby-btn" onclick="save();toast('游戏已保存')">💾 保存</button>
    <button class="lobby-btn" onclick="loadCharacterList()">🔄 切换角色</button>
    <button class="lobby-btn" onclick="confirmNewGame()">🗑 新游戏</button>
  </div>`;

  html += `</div>`;
  main.innerHTML = html;
}

// ========== NPC 对话 ==========

export function renderNPCDialogue(npcId) {
  const npc = NPCS[npcId];
  if(!npc) return;
  const main = document.getElementById('main');
  let dialogKey = 'default';
  const rep = window.getRepPath();
  if(npc.dialogues && npc.dialogues.rep_hero && rep === 'hero') dialogKey = 'rep_hero';
  else if(npc.dialogues && npc.dialogues.rep_shadow && rep === 'shadow') dialogKey = 'rep_shadow';
  else if(npc.dialogues && npc.dialogues.beat_sky && S.flags.beat_sky) dialogKey = 'beat_sky';
  else if(npc.dialogues && npc.dialogues.beat_hetonmar && S.flags.beat_hetonmar) dialogKey = 'beat_hetonmar';
  else if(npc.dialogues && npc.dialogues.beat_forest && S.flags.beat_forest) dialogKey = 'beat_forest';
  const lines = (npc.dialogues && npc.dialogues[dialogKey]) || (npc.dialogues && npc.dialogues.default) || ['……'];
  const line = lines[Math.floor(Math.random() * lines.length)];
  let html = '<div class="npc-dialogue-panel">';
  html += '<div class="npc-dialogue-header"><span class="npc-dialogue-back" onclick="renderLobby();renderTopbar();renderStatusbar();">← 返回</span>';
  html += '<span class="npc-dialogue-name">'+npc.emoji+' '+npc.name+'</span><span style="width:50px;"></span></div>';
  html += '<div class="npc-dialogue-body">';
  if(npc.image) {
    html += '<div class="npc-dialogue-avatar"><img src="'+npc.image+'" alt="'+npc.name+'" data-fallback="'+npc.emoji+'" style="width:80px;height:80px;border-radius:8px;object-fit:cover;" onerror="handleNPCImageError(this)"></div>';
  } else {
    html += '<div class="npc-dialogue-avatar">'+npc.emoji+'</div>';
  }
  html += '<div class="npc-dialogue-text">「'+line+'」</div></div>';
  const shopNPCs = ['sera','jarmerchant','blacksmith','kiri','grandis','norton','sosia','gsd'];
  if(shopNPCs.includes(npcId)) {
    html += '<button class="npc-dialogue-shop" onclick="openShopDirect(\''+npcId+'\')">🛒 看看商品</button>';
  }
  html += '</div>';
  main.innerHTML = html;
}

function handleNPCImageError(img) {
  const fallback = img.getAttribute('data-fallback') || '?';
  img.style.display = 'none';
  const parent = img.parentElement;
  if(parent) parent.textContent = fallback;
}
window.handleNPCImageError = handleNPCImageError;

// ========== 区域据点 ==========

export function renderRegionHub(regionId) {
  switchBGM(regionId);
  const main = document.getElementById('main');
  const reg = REGIONS.find(r => r.id === regionId);
  if(!reg) { window.goHome(); return; }
  if(!S.npcBoosts) S.npcBoosts = { atk:0, def:0, spd:0 };
  
  // 首次进入触发章节开场
  window.tryChapterPrologue(regionId);

  let html = `<div class="region-hub">`;
  html += `<div class="region-hub-title">${reg.icon} ${reg.name}</div>`;
  html += `<div class="region-hub-desc">${reg.desc}</div>`;

  // === NPC Section ===
  html += `<div class="region-hub-section">`;
  html += `<div class="region-hub-section-title">👥 据点住民</div>`;
  html += `<div class="npc-list">`;
  Object.values(NPCS).forEach(npc => {
    const isHere = npc.location.includes(regionId);
    if(!isHere) return;
    html += `<div class="npc-card" onclick="openNPCShop('${npc.id}')">
      <span class="npc-icon">${npc.emoji}</span>
      <div class="npc-info">
        <div class="npc-name">${npc.name} <span style="font-size:10px;color:var(--dim);">· ${npc.title}</span></div>
        <div class="npc-line">「${npc.desc}」</div>
      </div>
    </div>`;
  });
  html += `</div></div>`;

  // === Dungeon Section ===
  const dungeonList = DUNGEONS[regionId] || [];

  // 自动修复：如果后续副本已通关，自动补齐前置副本的标记
  const chain = DUNGEON_CHAINS[regionId] || [];
  for(let i = chain.length - 1; i >= 1; i--) {
    const nextDun = chain[i];
    const prevDun = chain[i-1];
    // 如果后续副本已通关，说明前置肯定也通了
    if(S.flags[`dungeon_${nextDun}_normal`] || S.flags[`dungeon_${nextDun}_hell`]) {
      if(!S.flags[`dungeon_${prevDun}_normal`] && !S.flags[`dungeon_${prevDun}_hell`]) {
        S.flags[`dungeon_${prevDun}_normal`] = true;
        console.log('[自动修复] 前置副本', prevDun, '标记已补齐');
      }
    }
  }
  // 自动修复：如果玩家当前场景明显超过了某个副本，自动标记该副本完成
  if(regionId === 'forest') {
    if(S.regionProgress.hetonmar || S.regionProgress.sky_city || S.flags.beat_hetonmar || S.flags.beat_sky) {
      chain.forEach(dunId => {
        if(!S.flags[`dungeon_${dunId}_normal`] && !S.flags[`dungeon_${dunId}_hell`]) {
          S.flags[`dungeon_${dunId}_normal`] = true;
          console.log('[自动修复] 区域进度已超前，副本', dunId, '标记已补齐');
        }
      });
    }
  } else if(regionId === 'hetonmar') {
    if(S.regionProgress.sky_city || S.flags.beat_sky) {
      chain.forEach(dunId => {
        if(!S.flags[`dungeon_${dunId}_normal`] && !S.flags[`dungeon_${dunId}_hell`]) {
          S.flags[`dungeon_${dunId}_normal`] = true;
          console.log('[自动修复] 区域进度已超前，副本', dunId, '标记已补齐');
        }
      });
    }
  }

  html += `<div class="region-hub-section">`;
  html += `<div class="region-hub-section-title">⚔️ 地下城入口</div>`;
  html += `<div class="dungeon-list">`;

  dungeonList.forEach(d => {
    let locked = false; let lockReason = '';
    if(d.lvReq && S.lv < d.lvReq) { locked = true; lockReason = `需要 Lv.${d.lvReq}（当前Lv.${S.lv}）`; }
    if(d.unlockAfter) {
      const normKey = `dungeon_${d.unlockAfter}_normal`;
      const hellKey = `dungeon_${d.unlockAfter}_hell`;
      if(!S.flags[normKey] && !S.flags[hellKey]) {
        if(!locked) { locked = true; const prev = window.findDungeonById(d.unlockAfter); lockReason = `需先通关：${prev?.name||d.unlockAfter}`; }
      }
    }
    const normalDone = S.flags[`dungeon_${d.id}_normal`];
    const hellDone = S.flags[`dungeon_${d.id}_hell`];

    html += `<div class="dungeon-card${locked?' locked':''}">`;
    html += `<div class="dungeon-card-header">`;
    html += `<span class="dungeon-name">${d.name}</span>`;
    html += `<span class="dungeon-lv">Lv.${d.lvReq}+</span>`;
    html += `</div>`;
    if(locked) {
      html += `<div class="dungeon-lock">🔒 ${lockReason}</div>`;
    }
    if(normalDone) html += `<div class="dungeon-status" style="color:var(--green);">✓ 普通模式已通关</div>`;
    if(hellDone) html += `<div class="dungeon-status" style="color:var(--red);">💀 恶魔模式已通关</div>`;
    if(!locked) {
      html += `<div class="dungeon-btns">`;
      html += `<button class="dungeon-btn${normalDone?' done':''}" onclick="enterDungeon('${d.id}','normal')">⚔️ 普通</button>`;
      html += `<button class="dungeon-btn hell${hellDone?' done':''}" onclick="enterDungeon('${d.id}','hell')">💀 恶魔</button>`;
      html += `</div>`;
      html += `<div class="dungeon-diff-info">🎲 随机生成 5-7 个房间 · 恶魔难度：怪物 HP/ATK +30%，金币+50%，稀有掉落+30% · 30%概率触发地下城异变</div>`;
    }
    html += `</div>`;
  });

  html += `</div></div>`;

  // 快捷操作
  if(dungeonList.length > 0) {
    const firstDun = dungeonList[0];
    if(S.lv >= firstDun.lvReq && !firstDun.unlockAfter) {
      html += `<button class="skip-hub-btn" onclick="enterDungeon('${firstDun.id}','normal')">跳过据点，直接进入第一个地下城</button>`;
    }
  }

  html += `<button class="continue-btn" style="margin-top:10px;" onclick="goHome()">返回大厅</button>`;

  // 调试信息（查看副本解锁状态）
  html += `<details style="margin-top:10px;font-size:9px;color:var(--dim);border:1px dashed var(--border);padding:6px;border-radius:6px;">
    <summary style="cursor:pointer;color:var(--dim);">🔍 调试：副本完成状态</summary>
    <div style="margin-top:4px;">`;
  const allDungeonIds = ['gf_dark_forest','gf_thunder','gf_poison','gf_flame','gf_dark_thunder',
    'ht_dungeon','ht_magic','sky_gate','sky_temple','sky_dragon_lair'];
  allDungeonIds.forEach(did => {
    const dn = S.flags[`dungeon_${did}_normal`] ? '✅' : '❌';
    const dh = S.flags[`dungeon_${did}_hell`] ? '💀' : '';
    html += `<span style="display:inline-block;width:48%;">${dn}${dh} ${did}</span>`;
  });
  html += `<div style="margin-top:4px;">当前场景: ${S.scene} | 区域: ${regionId} | Lv: ${S.lv}</div>`;
  html += `</div></details>`;

  html += `</div>`;

  main.innerHTML = html;
}

// ========== 职业选择 ==========

export function renderChooseClass() {
  const main = document.getElementById('main');
  let html = `
    <div class="story-box">
      <strong style="color:var(--gold);font-size:16px;">创建角色</strong>

      阿拉德历 977 年。
      你踏上这片土地，命运即将展开。

      选择你的职业，开始属于你的传说。
    </div>
    <div class="class-grid">`;

  const factions = ['鬼剑士','神枪手','圣职者'];
  const factionKeys = {
    '鬼剑士': ['sword','berserk','ghost','asura'],
    '神枪手': ['ranger','launcher'],
    '圣职者': ['crusader','monk'],
  };
  const factionColors = { '鬼剑士':'ghost', '神枪手':'gunner', '圣职者':'knight' };

  factions.forEach(faction => {
    html += `<div class="faction-label">── ${faction} ──</div>`;
    factionKeys[faction].forEach(k => {
      const v = CLASSES[k];
      html += `
        <button class="class-card faction-${factionColors[faction]}" onclick="pickClass('${k}')">
          <div>
            <span class="class-name">${v.name}</span>
            <span class="class-weapon">${v.weapon}</span>
          </div>
          <div class="class-desc">${v.desc}</div>
          <div class="class-skill-hint">💠 ${v.skillName}：${v.skillDesc}</div>
        </button>`;
    });
  });

  html += `</div>`;
  main.innerHTML = html;
}

// ========== 场景渲染 ==========

export function renderScene() {
  switchBGM(S.region || 'lobby');
  const main = document.getElementById('main');
  
  // 副本边界检查：如果在副本中但当前场景不属于该副本 → 回据点
  const inNewDungeon = S._dungeonRooms && S._dungeonRooms.length > 0;
  if(S.currentDungeon && !inNewDungeon && !S.currentDungeon.scenes.includes(S.scene)) {
    const regionId = window.getCurrentRegionId() || 'forest';
    S.scene = regionId;
    S.currentDungeon = null;
    S.currentDungeonDiff = null;
    S._hellMode = false;
    renderRegionHub(regionId);
    return;
  }
  if(S.scene === 'lobby') { renderLobby(); return; }

  // Check if scene is a region hub
  const isRegion = REGIONS.some(r => r.id === S.scene);
  if(isRegion) { renderRegionHub(S.scene); return; }

  const scene = window.getScene(S.scene);
  if(!scene) { main.innerHTML=`<div class="story-box">未知场景: ${S.scene}</div><button class="continue-btn" onclick="goHome()">返回大厅</button>`; return; }

  // 触发场景事件
  if(scene.onEnter) scene.onEnter();

  let html = `<div class="story-box"><strong style="color:var(--gold);font-size:14px;">【${scene.title}】</strong>\n\n${scene.text}</div>`;

  // Exp progress bar
  if(S.name) {
    const expPct = Math.min(100, Math.round(S.exp/S.expNeed*100));
    html += `<div class="exp-bar-wrap"><div class="exp-bar"><div class="exp-fill" style="width:${expPct}%"></div></div>
      <div class="exp-label">Exp ${S.exp}/${S.expNeed} (${expPct}%) · Lv.${S.lv}</div></div>`;
  }

  const filtered = scene.choices.filter(c=>{
    if(c.needLv && S.lv < c.needLv) return false;
    if(c.needGold && S.gold < c.needGold) return false;
    if(c.needItem && !window.hasItem(c.needItem)) return false;
    return true;
  });

  const locked = scene.choices.filter(c=>{
    if(c.needLv && S.lv < c.needLv) return true;
    return false;
  });

  if(filtered.length > 0) {
    html += '<div class="choices">';
    filtered.forEach((c,i)=>{
      const fatigueWarn = c.fatigue && S.fatigue < c.fatigue;
      const label = c.fatigue ? ` <span style="color:var(--dim);font-size:11px;">[消耗${c.fatigue}疲劳]</span>` : '';
      html += `<button class="choice-btn" onclick="if(${fatigueWarn}){toast('疲劳不足！返回大厅或使用疲劳药');return;}doChoice(${i})">${i+1}. ${c.text}${label}</button>`;
    });
    html += '</div>';
    // 探查周围按钮（25%概率出现，消耗HP/疲劳）
    if(S.scene !== 'lobby' && Math.random() < 0.25 && S.fatigue >= 3) {
      const cost = Math.floor(Math.random() * 10) + 5;
      html += `<button class="choice-btn" style="border-color:rgba(192,57,43,0.3);margin-top:6px;font-size:11px;" onclick="triggerRandomEvent()">🔍 探查周围 <span style="color:var(--red);font-size:10px;">[消耗${cost}HP]</span></button>`;
    }
  }

  if(locked.length > 0) {
    html += '<div style="margin-top:8px;">';
    locked.forEach(c=>{
      html += `<div style="font-size:11px;color:var(--dim);padding:6px 8px;border:1px dashed #333;border-radius:4px;margin-top:4px;">🔒 ${c.text} [需要 Lv.${c.needLv}]</div>`;
    });
    html += '</div>';
  }

  // 始终显示返回大厅按钮
  html += `<button class="continue-btn" style="margin-top:12px;" onclick="goHome()">🏠 返回大厅</button>`;

  main.innerHTML = html;
}

// ========== 任务日志 ==========

export function renderQuestLog() {
  const main = document.getElementById('main');
  const active = window.getActiveQuests();
  let html = '<div class="quest-log-panel">';
  html += '<div class="chapter-stories-header"><button class="ch-back-btn" onclick="renderLobby();renderTopbar();renderStatusbar();">← 返回</button>';
  html += '<span>📋 任务日志</span><span style="width:50px;"></span></div>';
  
  if(active.length === 0) {
    html += '<div style="text-align:center;color:var(--dim);padding:40px 20px;">暂无进行中的任务</div>';
  } else {
    html += '<div style="padding:0 16px;font-size:12px;color:var(--dim);margin-bottom:8px;">进行中 ('+active.length+')</div>';
    active.forEach(q => {
      const prog = S.quests.active[q.id] || 0;
      const pct = Math.min(100, Math.round(prog/q.objective.count*100));
      const labels = {kill:'击杀',kill_boss:'击败Boss',clear_dungeon:'通关副本',reach_lv:'等级'};
      html += '<div class="quest-card"><div class="quest-card-hd">';
      html += '<span class="quest-card-name">'+q.name+'</span>';
      html += '<span class="quest-card-prog">'+prog+'/'+q.objective.count+'</span></div>';
      html += '<div class="quest-card-bar"><div class="quest-card-fill" style="width:'+pct+'%"></div></div>';
      html += '<div class="quest-card-desc">'+labels[q.objective.type]+' · 💰'+q.reward.gold+'G</div></div>';
    });
  }

  // Completed
  if(S.quests.completed.length > 0) {
    html += '<div style="padding:16px 16px 4px;font-size:12px;color:var(--green);">已完成 ('+S.quests.completed.length+')</div>';
    S.quests.completed.forEach(qid => {
      const q = window.QUEST_DB.find(q=>q.id===qid);
      if(!q) return;
      html += '<div class="quest-card" style="opacity:0.6;"><div class="quest-card-hd">';
      html += '<span class="quest-card-name">✅ '+q.name+'</span></div></div>';
    });
  }
  html += '</div>';
  main.innerHTML = html;
}

// ========== 冒险笔记 ==========

export function renderNotebook() {
  const main = document.getElementById('main');
  let html = '<div class="notebook-panel">';
  html += '<div class="chapter-stories-header"><button class="ch-back-btn" onclick="renderLobby();renderTopbar();renderStatusbar();">← 返回</button>';
  html += '<span>📓 冒险笔记</span><span style="width:50px;"></span></div>';
  
  let hasAny = false;
  // 包含任务笔记
  if(window.ADVENTURE_NOTES.quests) {
    window.ADVENTURE_NOTES.quests.forEach(note => {
      if(!S.flags[note.flag]) return;
      hasAny = true;
      html += '<div class="note-card"><div class="note-header">';
      html += '<span class="note-icon">'+note.icon+'</span>';
      html += '<div><div class="note-title">'+note.title+'</div>';
      html += '<div class="note-date">'+note.date+'</div></div></div>';
      html += '<div class="note-text">'+note.text+'</div></div>';
    });
  }
  Object.entries(window.ADVENTURE_NOTES).forEach(([key, entries]) => {
    entries.forEach(note => {
      if(!S.flags[note.flag]) return;
      hasAny = true;
      html += '<div class="note-card"><div class="note-header">';
      html += '<span class="note-icon">'+note.icon+'</span>';
      html += '<div><div class="note-title">'+note.title+'</div>';
      html += '<div class="note-date">'+note.date+'</div></div></div>';
      html += '<div class="note-text">'+note.text+'</div></div>';
    });
  });
  
  if(!hasAny) {
    html += '<div style="text-align:center;color:var(--dim);padding:40px 20px;font-size:14px;">📓 暂无冒险记录<br><span style="font-size:11px;">随着冒险推进，笔记将自动记录你的发现</span></div>';
  }
  html += '</div>';
  main.innerHTML = html;
}

// ========== 章节故事 ==========

export function renderChapterStories() {
  const main = document.getElementById('main');
  let html = `<div class="chapter-stories-panel">
    <div class="chapter-stories-header">
      <button class="ch-back-btn" onclick="renderLobby();renderTopbar();renderStatusbar();">← 返回</button>
      <span>📖 章节故事</span>
      <span style="width:50px;"></span>
    </div>`;

  let hasAny = false;
  Object.entries(window.CHAPTER_STORIES).forEach(([key, ch]) => {
    if(!S.flags[ch.unlockFlag]) return;
    hasAny = true;

    html += `<div class="chapter-card">
      ${ch.image ? `<div class="chapter-card-image"><img src="${ch.image}" alt="${ch.title}" style="width:100%;max-width:400px;display:block;margin:0 auto 16px;border-radius:6px;" onerror="this.style.display='none'"></div>` : ''}
      <div class="chapter-card-title">${ch.icon} ${ch.title}</div>
      
      <div class="chapter-section">
        <div class="chapter-section-label">◇ 开篇 · 缘起</div>
        <div class="chapter-text">${ch.prologue.replace(/\n/g,'<br>')}</div>
      </div>
      
      <div class="chapter-divider">◆ ◆ ◆</div>
      
      <div class="chapter-section">
        <div class="chapter-section-label">◇ 结局 · 余韵</div>
        <div class="chapter-text">${ch.epilogue.replace(/\n/g,'<br>')}</div>
      </div>
    </div>`;
  });

  if(!hasAny) {
    html += `<div style="text-align:center;color:var(--dim);padding:40px 20px;font-size:14px;">
      🔒 暂无解锁的章节故事<br>
      <span style="font-size:11px;">完成各地区冒险后将解锁对应章节</span>
    </div>`;
  }

  html += `</div>`;
  main.innerHTML = html;
}

// ========== 章节结局/开场叙事 ==========

export function renderChapterEpilogue(regionId, onDone) {
  const ep = window.CHAPTER_EPILOGUES[regionId];
  if(!ep) { if(onDone) onDone(); return; }

  const main = document.getElementById('main');
  main.innerHTML = '';

  // overlay
  const overlay = document.createElement('div');
  overlay.className = 'epilogue-overlay';

  // title
  const title = document.createElement('div');
  title.className = 'epilogue-title';
  title.textContent = ep.title;
  overlay.appendChild(title);

  // chapter art image
  const artSrc = window.CHAPTER_ART[regionId];
  if(artSrc) {
    const img = document.createElement('img');
    img.src = artSrc;
    img.style.cssText = 'display:block;width:280px;height:auto;margin:16px auto 8px;border-radius:8px;opacity:0.85;border:1px solid rgba(255,255,255,0.1);';
    img.onerror = () => { img.style.display = 'none'; };
    overlay.appendChild(img);
  }

  // scroll container
  const scroll = document.createElement('div');
  scroll.className = 'epilogue-scroll';

  const lines = document.createElement('div');
  lines.className = 'epilogue-lines';

  ep.lines.forEach((line, i) => {
    const p = document.createElement('p');
    p.className = 'epilogue-line' + (line.cls ? ' ' + line.cls : '');
    p.style.animationDelay = (0.6 + i * 0.35) + 's';
    p.textContent = line.text;
    lines.appendChild(p);
  });

  scroll.appendChild(lines);
  overlay.appendChild(scroll);

  // skip button
  const skip = document.createElement('div');
  skip.className = 'epilogue-skip';
  skip.textContent = '点击跳过 ▶';
  skip.onclick = () => {
    if(onDone) onDone();
    overlay.remove();
  };
  overlay.appendChild(skip);

  // auto-dismiss after scroll
  const totalDuration = 600 + ep.lines.length * 350 + 3000;
  const timer = setTimeout(() => {
    if(onDone) onDone();
    overlay.remove();
  }, totalDuration);

  // replace timer when skipped
  clearTimeout(skip._timer);
  skip.onclick = () => {
    clearTimeout(timer);
    if(onDone) onDone();
    overlay.remove();
  };

  document.body.appendChild(overlay);
}

export function renderChapterPrologue(regionId, onDone) {
  const ch = window.CHAPTER_STORIES[regionId];
  if(!ch || !ch.prologue) { if(onDone) onDone(); return; }
  
  const overlay = document.createElement('div');
  overlay.className = 'epilogue-overlay';
  overlay.style.background = 'rgba(0,0,0,0.95)';
  
  const title = document.createElement('div');
  title.className = 'epilogue-title';
  title.textContent = ch.icon + ' ' + ch.title;
  overlay.appendChild(title);

  // chapter art image
  if(ch.image) {
    const img = document.createElement('img');
    img.src = ch.image;
    img.style.cssText = 'display:block;width:280px;height:auto;margin:16px auto 8px;border-radius:8px;opacity:0.85;border:1px solid rgba(255,255,255,0.1);animation:epiFadeIn 1s ease 0.3s both;';
    img.onerror = () => { img.style.display = 'none'; };
    overlay.appendChild(img);
  }
  
  const scroll = document.createElement('div');
  scroll.className = 'epilogue-scroll';
  const lines = document.createElement('div');
  lines.className = 'epilogue-lines';
  
  const prologueLines = ch.prologue.split('\n').filter(l => l.trim());
  prologueLines.forEach((line, i) => {
    const p = document.createElement('p');
    const cls = line.startsWith('——') ? 'highlight' : (line.includes('·') || line.includes('★') ? 'highlight' : '');
    p.className = 'epilogue-line' + (cls ? ' ' + cls : '');
    p.style.animationDelay = (0.5 + i * 0.3) + 's';
    p.textContent = line;
    lines.appendChild(p);
  });
  
  // 开始探索按钮
  const enterBtn = document.createElement('div');
  enterBtn.style.cssText = 'position:fixed;bottom:60px;left:50%;transform:translateX(-50%);z-index:1010;opacity:0;animation:epiFadeIn 1s ease 3s forwards;';
  enterBtn.innerHTML = '<button class="choice-btn" style="border-color:var(--gold);font-size:16px;text-align:center;padding:12px 32px;">⚔️ 开始探索</button>';
  enterBtn.onclick = () => {
    if(onDone) onDone();
    overlay.remove();
  };
  
  scroll.appendChild(lines);
  overlay.appendChild(scroll);
  overlay.appendChild(enterBtn);
  document.body.appendChild(overlay);
  
  const totalDuration = 500 + prologueLines.length * 300 + 4000;
  setTimeout(() => { if(onDone) onDone(); overlay.remove(); }, totalDuration);
}

// ========== 战斗渲染 ==========

export function renderCombat() {
  try {
  if(!S.combat) { console.warn('renderCombat: S.combat is null'); return; }
  switchBGM('battle');
  const main = document.getElementById('main');
  const c = S.combat;
  if(!S.mp && S.mp !== 0) S.mp = 50;
  const cls = S.cls ? CLASSES[S.cls] : null;

  const logHtml = c.log.slice(-5).map(l=>`<div style="font-size:11px;margin:1px 0;line-height:1.5;">${l}</div>`).join('');

  const php = Math.max(0, Math.round(S.hp / S.maxHp * 100));
  const mhp = Math.max(0, Math.round(c.monHp / c.monMaxHp * 100));
  const mpPct = Math.max(0, Math.round((S.mp||0) / (S.maxMp||50) * 100));

  const potionCount = (S.inventory||[]).filter(i=>CONSUMABLES[i.id]).length;
  
  // 技能网格数据
  const skills = window.getAvailableSkills();
  const skillGridHtml = skills.length > 0 ? skills.map(sk => {
    let skcls = 'skill-slot';
    let onclick = `combatSkill('${sk.id}')`;
    let statusText = '';
    let disabled = '';
    
    if(!sk.unlocked) {
      skcls += ' locked'; disabled = 'disabled'; onclick = '';
      statusText = `🔒 Lv.${window.SKILLS_DB[sk.id]?.unlockLv||'?'}`;
    } else if(sk.cooldown > 0) {
      skcls += ' cd'; disabled = 'disabled'; onclick = '';
      statusText = `⏳ CD:${sk.cooldown}`;
    } else if(!sk.hasMp) {
      skcls += ' nomp'; disabled = 'disabled'; onclick = '';
      statusText = `MP不足`;
    } else {
      statusText = `MP${sk.cost}`;
    }
    
    return `<button class="${skcls}" onclick="${onclick}" ${disabled}>
      <span class="skill-icon">${sk.icon||'💠'}</span>
      <span class="skill-name">${sk.name}</span>
      <span class="skill-status">${statusText}</span>
    </button>`;
  }).join('') : '<div style="grid-column:1/-1;text-align:center;color:var(--dim);font-size:11px;">无可用技能</div>';
  
  const BOSS_PHASE_TEXTS = {
    'bone_dragon':  { hint:'💀 骨狱息从尸堆中汲取亡灵之力！', log:['腐尸在骨狱息周围重新站起——它从满地骸骨中抽出了新的力量！','攻击力+20！'] },
    'flame_boss':   { hint:'🔥 烈焰彼诺修点燃了整个房间！', log:['火焰彼诺修发出尖啸——半个房间化为了熔岩！','攻击力+15！'] },
    'ice_witch':    { hint:'❄️ 冰封女巫释放了全部魔力！', log:['冰晶从女巫体内爆裂而出——她不惜摧毁自己的身体也要阻止你！','攻击力+18！'] },
    'golem_guard':  { hint:'🪨 地界守卫者崩裂重组成更强形态！', log:['巨石坠落又重组——守卫者以更狰狞的形态站了起来！','攻击力+12！'] },
    'cloud_gargoyle':{ hint:'🗿 石像鬼从石化的诅咒中解脱！', log:['石化的外壳崩裂——石像鬼露出了它真正的恶魔形态！','攻击力+12！'] },
    'spider_queen': { hint:'🕷️ 蜘蛛女王陷入疯狂喷吐毒雾！', log:['蛛巢的墙壁上渗出毒液——蜘蛛女王吞噬了自己的卵来获取力量！','攻击力+16！'] },
    'sky_dragon':   { hint:'🐉 龙晶碎裂……巴卡尔的残响苏醒！', log:['天空龙王发出震天龙鸣——龙晶碎裂，巴卡尔的残响从远古苏醒！','「你竟能伤我到如此地步……接受真正的试炼吧！」攻击力+25！'] },
  };

  const phaseHint = c.multiPhase && !c.phase2Triggered && c.monHp <= c.phase2Hp
    ? (BOSS_PHASE_TEXTS[c.monId]
      ? `<div style="color:#ff0;font-size:12px;text-align:center;animation:hitFlash 0.5s ease;">${BOSS_PHASE_TEXTS[c.monId].hint}</div>`
      : `<div style="color:var(--red);font-size:11px;text-align:center;animation:hitFlash 0.5s ease;">⚠ ${c.monName} 进入狂暴形态！</div>`)
    : '';

  const playerImg = S.cls ? `assets/class_${S.cls}.png` : '';
  const regionClass = c.isBoss ? ' region-boss' : (window.getCurrentRegionId() ? ` region-${window.getCurrentRegionId()}` : '');

  main.innerHTML = `
    <div class="combat-box${regionClass}">
      <div style="text-align:center;color:${c.monColor};font-size:14px;margin-bottom:6px;">
        ${c.isBoss ? '💀 ' : '⚔️ '}${c.monName} Lv.${c.monLv}${c.isBoss ? ' 💀' : ''}
      </div>
      ${phaseHint}
      <div class="combat-illust" id="combatIllust">
        <div class="fighter-wrap player-wrap" id="playerWrap">
          <img src="${playerImg}" onerror="this.style.display='none'" alt="player">
          <div class="fighter-label">${S.name}</div>
        </div>
        <div class="vs-zone">
          <div class="vs-text">VS</div>
          <div class="vs-line"></div>
        </div>
        <div class="fighter-wrap monster-wrap" id="monsterWrap">
          ${getMonsterImage(c.monsterId)}
          <div class="fighter-label">${c.monName}</div>
        </div>
        <div class="projectile" id="projectile"></div>
        <div class="hit-burst" id="hitBurst"></div>
      </div>
      <div class="combat-hp">
        <span style="color:var(--green)">${S.name}</span>
        <span style="color:${c.monColor}">${c.monName}</span>
      </div>
      <div class="hp-bar"><div class="hp-fill player" style="width:${php}%"></div></div>
      <div class="combat-hp" style="margin-top:2px;">
        <span>❤️ ${S.hp}/${S.maxHp}</span>
        <span style="color:${c.monColor}">❤️ ${c.monHp}/${c.monMaxHp}</span>
      </div>
      <div class="hp-bar"><div class="hp-fill" style="width:${mhp}%"></div></div>
      <div class="mp-bar"><div class="mp-fill" style="width:${mpPct}%"></div></div>
      <div style="font-size:9px;color:var(--dim);text-align:right;margin-top:1px;">💠 技力 ${S.mp||0}/${S.maxMp||50}</div>
      ${logHtml}
    </div>
    <div class="skill-grid">${skillGridHtml}</div>
    ${(()=>{
      // 觉醒按钮 - 仅在Lv.50+且有觉醒技能时显示
      if(S.lv < 50 || !S.cls) return '';
      const awakenId = S.cls + '_awaken';
      const ak = window.SKILLS_DB[awakenId];
      if(!ak) return '';
      const cd = (window.S && window.S._skillCooldowns && window.S._skillCooldowns[awakenId]) || 0;
      const hasMp = (S.mp||0) >= (ak.cost||0);
      const ready = cd === 0 && hasMp;
      const imgSrc = 'assets/npc/awaken_'+S.cls+'.png';
      return '<div style="text-align:center;margin:4px 0;">'+
        '<button class="awaken-btn'+(ready?' ready':' locked')+'" onclick="'+(ready?'combatSkill(\''+awakenId+'\')':'')+'" '+(ready?'':'disabled')+' style="background:linear-gradient(135deg,#2a1a00,#3d2000);border:2px solid '+(ready?'var(--gold)':'#444')+';border-radius:8px;padding:8px 20px;color:'+(ready?'var(--gold)':'#555')+';font-size:13px;cursor:'+(ready?'pointer':'not-allowed')+';width:100%;max-width:300px;">'+
        '<img src="'+imgSrc+'" onerror="this.style.display=\'none\'" style="width:40px;height:40px;border-radius:4px;vertical-align:middle;margin-right:8px;object-fit:cover;">'+
        '<span style="font-weight:bold;">🌟 '+ak.name+'</span>'+
        '<span style="font-size:10px;margin-left:8px;">'+(ready?'MP'+ak.cost:'⏳ CD:'+cd)+'</span>'+
        '</button></div>';
    })()}
    <div class="btn-row">
      <button class="btn" onclick="combatAttack()">⚔️ 普攻</button>
      <button class="btn" onclick="combatPotion()" ${potionCount===0?'disabled':''}>🧪 药水</button>
      <button class="btn danger" onclick="combatFlee()">🏃 逃跑</button>
    </div>
  `;
  } catch(e) {
    console.error('renderCombat error:', e.message, e.stack);
    const main = document.getElementById('main');
    main.innerHTML = `<div style="color:var(--red);text-align:center;padding:40px;">
      ⚠️ 战斗渲染错误: ${e.message}<br>
      <button onclick="window.reloadPage()" style="margin-top:16px;">🔄 刷新页面</button>
    </div>`;
  }
}
